import { FETCH_DCC, GET_CONTACT } from './types';
import { getDCC } from 'services/groups.service';
import * as contactSvc from 'services/contacts.service';

export const getDCCData = (groupHash, contactHash) => ({
  type: FETCH_DCC,
  payload: {
    promise: getDCC(groupHash, contactHash),
  },
});

export const getContact = (contactHash) => ({
  type: GET_CONTACT,
  payload: {
    promise: contactSvc.getContact({ hash: contactHash }),
  },
});
